import React from 'react';
import swal from 'sweetalert';
import { GridCell } from '@progress/kendo-react-grid';

export default function CellWithEditing(toggleActive) {
	return class extends GridCell {
		render() {
			return (
				<td>
					{/* <button
						className="admin-k-button "
						onClick={() => {
							edit(this.props.dataItem);
						}}
					>
						<i className="fas fa-pen"></i>
						EDIT
					</button> */}
					&nbsp;
					{this.props.dataItem.isActive ? (
						<button
              style={{ width: 'auto' }} 
							className="admin-k-button "
							onClick={() => {
								swal({
									title: 'Are you sure?',
									text: `Member will be deactivated, from the ${this.props.dataItem.positionName} Position`,
									icon: 'warning',
									buttons: {
										cancel: 'CANCEL',
										confirm: 'OK'
									},
									dangerMode: true
								}).then((value) => (value ? toggleActive(this.props.dataItem) : null));
							}}
						>
							<i className="fas fa-times-circle"></i>
						</button>
					) : (
						<button
              style={{ width: 'auto' }} 
							className="admin-k-button "
							onClick={() => {
								swal(
									`Are you sure you want to re-activate ${this.props.dataItem.firstName}${this.props.dataItem.lastName} ?`
								).then((value) => (value ? toggleActive(this.props.dataItem) : null));
							}}
						>
							<i className="fas fa-check-circle"></i>
						</button>
					)}
				</td>
			);
		}
	};
}
